import { combineReducers } from 'redux';
import dataSources from './dataSources';
import sportData from './sportData';
import events from './events';
import modal from './modal';
import ads from './ads';
import routeParams from './routeParams';
import search from './search';
import broadcastAreaData from './broadcastAreaData';
import mappedSportRouteParam from './mappedSportRouteParam';
import selectedTemplates from './selectedTemplates';
import userRating from './userRating';
import tagValues from './tagValues';

const subStateReducers = {
  events,
  dataSources,
  modal,
  ads,
  sportData,
  routeParams,
  search,
  broadcastAreaData,
  mappedSportRouteParam,
  selectedTemplates,
  userRating,
  tagValues,

  // keeping some extra stuff in state that we don't need reducers for
  // (redux complains if you put stuff in the state without a reducer, or
  // if you return undefined... note that null will actually never be in the
  // state, because there properties are set in the initial state)
  country: state => state ? state : null,
  language: state => state ? state : null,
  serverTime: state => state ? state : null,
};

export default combineReducers(subStateReducers);



// WEBPACK FOOTER //
// ./src/reducer/rootReducer.js